// extracted by mini-css-extract-plugin
export default {"fill":"topToolbar_fill__ZBgmC"};